/** When your routing table is too long, you can split it into small modules **/

import AuthLayout from '@/layout/AuthLayout';

const authLayoutRouter = {
  path: '/auth',
  component: AuthLayout,
  redirect: '/sign-in',
  hidden: true,
  meta: {
    title: 'Auth',
    icon: 'component'
  },
  children: [
    {
      path: '/sign-in',
      component: () => import('@/views/auth/SignIn'),
      name: 'SingIn',
      meta: {
        title: 'Iniciar Sesión',
        icon: 'mdi-view-dashboard-outline',
        affix: true
      }
    },
    {
      path: '/select-country',
      component: () => import('@/views/auth/SelectCountry'),
      name: 'select-country',
      alias: '/seleccione-pais',
      meta: {
        title: 'Seleccione País',
        icon: 'mdi-timer-outline',
        affix: true
      }
    },
    {
      path: '/account-type',
      component: () => import('@/views/auth/AccountType'),
      name: 'account-type',
      meta: {
        title: 'Tipo de Cuenta',
        icon: 'mdi-timer-outline',
        affix: true
      }
    },
    {
      path: '/organization-id',
      component: () => import('@/views/auth/OrganizationID'),
      name: 'organization-id',
      meta: {
        title: 'Id de Organización',
        icon: 'mdi-timer-outline',
        affix: true
      }
    },
    {
      path: '/subscription-type',
      component: () => import('@/views/auth/SubscriptionType'),
      name: 'subscription-type',
      meta: {
        title: 'Tipo de Suscripción',
        icon: 'mdi-timer-outline',
        affix: true
      }
    },
    {
      path: '/sign-up',
      component: () => import('@/views/auth/SignUp'),
      name: 'sign-up',
      meta: {
        title: 'Registrar Cuenta',
        icon: 'mdi-timer-outline',
        affix: true
      }
    },
    {
      path: '/forgot-password',
      component: () => import('@/views/auth/ForgotPassword'),
      name: 'forgot-password',
      meta: {
        title: 'Resetear Contraseña',
        icon: 'mdi-timer-outline',
        affix: true
      }
    },
    {
      path: '/email-verify',
      component: () => import('@/views/auth/EmailVerify'),
      name: 'email-verify',
      meta: {
        title: 'Verifición de Correo Electrónico',
        icon: 'mdi-timer-outline',
        affix: true,
        requiresAuth: true
      }
    }
  ]
};

export default authLayoutRouter;
